import { Component } from '@angular/core';
import { UilabMatTableModule } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface TableRow {
    readonly name: string;
    readonly owner: string;
    readonly status: string;
}

interface TableExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly rows: readonly TableRow[];
}

@Component({
    selector: 'avd-table-examples',
    templateUrl: './table-examples.component.html',
    styleUrls: ['./table-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatTableModule,
    ],
})
export class TableExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/story/components-table--default`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/table`;

    readonly displayedColumns = ['name', 'owner', 'status'];

    readonly examples: readonly TableExample[] = [
        {
            variant: 'basic',
            label: 'Basic Table',
            description:
                'Use a basic table to present structured records with clear column headers and quick row scanning.',
            htmlSnippet: `<table uilab-mat-table [dataSource]="tableData">
    <ng-container uilabMatColumnDef="name">
        <th uilab-mat-header-cell *uilabMatHeaderCellDef>Name</th>
        <td uilab-mat-cell *uilabMatCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <ng-container uilabMatColumnDef="owner">
        <th uilab-mat-header-cell *uilabMatHeaderCellDef>Owner</th>
        <td uilab-mat-cell *uilabMatCellDef="let row">{{ row.owner }}</td>
    </ng-container>

    <ng-container uilabMatColumnDef="status">
        <th uilab-mat-header-cell *uilabMatHeaderCellDef>Status</th>
        <td uilab-mat-cell *uilabMatCellDef="let row">{{ row.status }}</td>
    </ng-container>

    <tr uilab-mat-header-row *uilabMatHeaderRowDef="displayedColumns"></tr>
    <tr uilab-mat-row *uilabMatRowDef="let row; columns: displayedColumns"></tr>
</table>`,
            rows: [
                {
                    name: 'Compressor A-101',
                    owner: 'Operations',
                    status: 'Healthy',
                },
                {
                    name: 'Pump P-204',
                    owner: 'Maintenance',
                    status: 'Needs review',
                },
                {
                    name: 'Boiler B-12',
                    owner: 'Utilities',
                    status: 'Offline',
                },
            ],
        },
    ];
}
